import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  open(event) { if(event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const dialog = document.querySelector("dialog[data-controller='gallery']");
    if(!dialog) return;
    event.preventDefault();
    dialog.dispatchEvent(new CustomEvent("gallery:open", { detail: { trigger: this.element } }));
  }
}
